export default "__VITE_ASSET__CpEoXMsU__"